import React from "react";
import {connect} from 'react-redux';
import {Redirect} from "react-router";
import {Dispatch} from 'redux';
import {PaymentDialog, Settings} from "../../http/protocol";
import {t} from "../../i18n";
import {DepositState, WithdrawPhase, WithdrawState} from "../../payments/PaymentsReducer";
import {initWithdraw} from '../../payments/WithdrawActions';
import getLoggedInRedirect from "../../utils/LoggedInRedirect";
import WithdrawChooseAmount from "../withdraw/ChooseAmount";
import WithdrawResponseView from '../withdraw/WithdrawResponseView';
import { ReactNode } from "react-markdown";


interface Props {
    type: string
    withdraw? : WithdrawState;
    handleClickOk?: () => void;
    handleClickStartPlaying?: () => void;
    deposit? : DepositState;
    dialog? : PaymentDialog;
    settings?: Settings;
    fromBonus?:boolean;
    initWithdraw? : typeof initWithdraw
}

interface State {
    startPlaying:boolean;
}

type AllProps = Props;


class AgentPaymentComponent extends React.Component<AllProps, State> {
    constructor(props:AllProps) {
        super(props);

        this.state = {startPlaying:false}
    }

    componentDidUpdate(prevProps: AllProps, nextState: State) {
        if (!prevProps.withdraw  ||  !this.props.withdraw) {
            return;
        }

        if (prevProps.withdraw?.phase != WithdrawPhase.CONFIRM_WITHDRAW  &&  this.props.withdraw?.phase == WithdrawPhase.CONFIRM_WITHDRAW) {
            this.props.initWithdraw?.();
        }
    }


    renderWithdraw() {
        const withdraw = this.props.withdraw != undefined ? this.props.withdraw : {};
        const phase = withdraw && withdraw.phase;
        const resp = this.props.withdraw?.withdrawResponse;

        return(
            <div className="withdraw-title">
                {(phase === WithdrawPhase.CHOOSE_ADDRESS  ||  phase === WithdrawPhase.CHOOSE_AMOUNT  ||  phase === WithdrawPhase.CHOOSE_PROVIDER) && (
                    <WithdrawChooseAmount />
                )}

                {(phase === WithdrawPhase.WITHDRAW_RESPONSE || phase === WithdrawPhase.CONFIRM_WITHDRAW) && withdraw && this.props.handleClickOk && (
                    <WithdrawResponseView 
                        onClick={this.props.handleClickOk}
                        overrideTitleKey='payments.method.agent.withdraw.success.title'
                        overrideTextKey='payments.method.agent.withdraw.success.text'
                    />
                )}

                {phase === WithdrawPhase.REQUEST_DENIED && (
                    <div className="requestDenied">
                        <span>{t(`withdraw.requestDenied-reason.${withdraw.withdrawResponse?.result ?? 'ERROR'}`)}</span>
                    </div>
                )}
                
                {phase === WithdrawPhase.ERROR && (
                    <div className="requestDenied">
                        <span>{t("withdraw.withdrawError")}</span>
                    </div>
                )}
            </div>
        )
    }

    renderDeposit() {
        return(
            <div>
                <span>{t(`payments.method.agent.deposit.description`)}</span>
            </div>
        )
    }

    render(): ReactNode | ReactNode[]  {
        if(this.state.startPlaying && this.props.settings) {
            return <Redirect to={getLoggedInRedirect(this.props.settings)} />
        }

        if(this.props.type == "withdraw") {
            return this.renderWithdraw()
        }
        if(this.props.type == "deposit") {
            return  this.renderDeposit()
        }
    }
}

const mapDispatchToProps = (dispatch: Dispatch)=> ({
    initWithdraw : () => dispatch(initWithdraw() as any)

});

export default connect(null as any,mapDispatchToProps)(AgentPaymentComponent as any) as any;